import { RecommendationsComponent } from 'components/main/recommendations/recommendations.component'
export default RecommendationsComponent
